import script from "./LogsPage.vue?vue&type=script&setup=true&lang=js"
export * from "./LogsPage.vue?vue&type=script&setup=true&lang=js"

import "./LogsPage.vue?vue&type=style&index=0&id=dab42ff6&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-dab42ff6"]])

export default __exports__